export const DEFAULT_APP_VERSION = '1.0.0';
